module.exports = __webpack_public_path__ + "static/icons/icon-menu-up-c5c94b971f83b30a26b34a34e652e3f1.svg";